import React from 'react';

import { OrderFillsCapsuleContentValues } from './OrderFillsCapsuleContentValues';
import { OrderFillsCapsuleContentPie } from './OrderFillsCapsuleContentPie';
import { useOrderFillsCapsuleData } from '../useOrderFillsCapsuleData';

import './OrderFillsCapsuleContent.scss';

export function OrderFillsCapsuleContent() {
    const data = useOrderFillsCapsuleData();

    return (
        <div className="OrderFillsCapsuleContent">
            <OrderFillsCapsuleContentPie data={data} />
            <OrderFillsCapsuleContentValues data={data} />
        </div>
    );
}
